// Review R3 L6 (Session FR4). What the office is told after it presses Void on a quote. The server's answer says whether the
// signing request in Signable was cancelled; "voided" on its own claimed more than happened when Signable did not confirm the
// cancel, because the customer could then still sign the old request. Two pages show the result (the Quotes list and the quote
// page) and read the sentence from here so they cannot say different things.
export type VoidResult = { ok: boolean; status: string; envelopeVoided: boolean; envelopeNotCancelled?: boolean };

/** `kind: "error"` is shown as a red alert; the quote is voided on the platform either way. */
export function voidOutcome(subject: string, res: VoidResult | undefined): { kind: "ok" | "error"; text: string } {
  if (res?.envelopeNotCancelled) {
    return {
      kind: "error",
      text: `${subject} is voided here, but Signable did not confirm that its signing request was cancelled, so the customer may still be able to sign it. Cancel it in Signable's own dashboard as well. Nothing has been activated.`,
    };
  }
  if (res?.envelopeVoided) {
    return { kind: "ok", text: `${subject} voided and its signing request cancelled in Signable. You can now build a corrected quote.` };
  }
  return { kind: "ok", text: `${subject} voided. You can now build a corrected quote.` };
}
